// Resolve a US 5-digit ZIP to { city, state } via the free Zippopotam.us API
// (no key, no billing). Returns null on miss/error so the form just falls back
// to manual entry.
export async function fetchZipLocation(zip) {
  if (!/^\d{5}$/.test(String(zip || ''))) return null;
  try {
    const res = await fetch(`https://api.zippopotam.us/us/${zip}`);
    if (!res.ok) return null;
    const data = await res.json();
    const place = data.places && data.places[0];
    if (!place) return null;
    return { city: place['place name'] || '', state: place['state abbreviation'] || '' };
  } catch {
    return null;
  }
}
